import {PcsDetailType, PcsSubjectElementType} from "../interface";
import React, {Dispatch, SetStateAction, useEffect, useState} from "react";
import {useForm, useWatch} from "react-hook-form";
import SearchProductInner from "../../../../../components/common/modal/inner/SearchProductInner";
import {useModal} from "../../../../../hooks";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import {pcsListElementSubjectListElementInit} from "../../list/state";
import {useSavePurchaseOrderSubject} from "../hooks/useSavePurchaseOrderSubject";
import {useQueryClient} from "@tanstack/react-query";
import InputNumberUc from "../../../../../components/common/number/InputNumberUc";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";

interface PropsType {
    pcsDetail: PcsDetailType
    pcsSubject: PcsSubjectElementType[]
    setIsModify: Dispatch<SetStateAction<boolean>>
    modifyTrigger: boolean
    setModifyTrigger: Dispatch<SetStateAction<boolean>>
    menuTitleText: string
}

interface UpdateDataType {
    list: PcsSubjectElementType[]
}

export default function Tab2Modify({
                                       pcsDetail,
                                       pcsSubject,
                                       setIsModify,
                                       modifyTrigger,
                                       setModifyTrigger,
                                       menuTitleText
                                   }: PropsType) {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const updateData: UpdateDataType = {list: pcsSubject}

    const {mutateAsync: mutateAsyncSavePurchaseOrderSubject} = useSavePurchaseOrderSubject()

    const [checkedIdx, setCheckedIdx] = useState<number[]>([])

    const {register, handleSubmit, getValues, control, setValue, watch} = useForm({
        defaultValues: updateData,
    });

    const watchUpdateData = {
        ...updateData,
        ...useWatch<UpdateDataType>({control}),
    } as UpdateDataType;

    const isAllCheck = watchUpdateData.list.length !== 0
        && watchUpdateData.list.every((el, idx) => checkedIdx.includes(idx))

    const btnSearchProduct = (idx: number) => {
        handleModal({
            isOpen: true,
            contents: <SearchProductInner
                confirmCallback={(item) => {
                    const product = item.productDetailRes

                    const list = getValues("list").map((el, idx2) => {
                        if (idx === idx2) {
                            return {
                                ...el,
                                newLErpProductValue: product.newErpProductid,
                                productName: product.newTxtNmItem,
                                newTxtStandard: product.newTxtStndItem,
                                purchaseOrderId: pcsDetail.purchaseOrderId,
                                productRange: product.productRange,
                                productGroupName: product.productRange,
                                newProductGroupid: product.newLProductGroupValue
                            }
                        } else {
                            return el
                        }
                    })

                    setValue("list", list)
                }}
                modalDepth={1}
            />,
            type: "",
            title: "제품 조회",
            modalSize: "xxl"
        })
    }

    const clickCheck = (idx: number) => {
        if (checkedIdx.includes(idx)) {
            setCheckedIdx(checkedIdx.filter(el => el !== idx))
        } else {
            setCheckedIdx([...checkedIdx, idx])
        }
    }

    const clickAllCheck = () => {
        if (!isAllCheck) {
            setCheckedIdx(Array.from({length: watchUpdateData.list.length}, (_, i) => i))
        } else {
            setCheckedIdx([])
        }
    }

    const btnAdd = () => {
        const list = [...getValues("list"), pcsListElementSubjectListElementInit]

        setValue("list", list)
    }

    const btnDelete = () => {
        const list = getValues("list").filter((_, idx) => !checkedIdx.includes(idx))

        setValue("list", list)
    }

    const saveCallback = (submitData: PcsSubjectElementType[]) => {
        if (submitData.length === 0) {
            handleModal({
                isOpen: true,
                contents: `${menuTitleText}품목을 추가해주세요.`,
                type: "alert",
            })
        } else if (submitData.some(el => el.newLErpProductValue === "")) {
            handleModal({
                isOpen: true,
                contents: `${menuTitleText}품목을 선택해주세요.`,
                type: "alert",
            })
        } else {
            mutateAsyncSavePurchaseOrderSubject(submitData).then(res => {
                if (res.data.code === "0000") {
                    handleModal({
                        isOpen: true,
                        contents: "저장되었습니다.",
                        type: "alert",
                        closeAction: () => {
                            qc.invalidateQueries({queryKey: ["readPurchaseOrderSubject"]})
                            setIsModify(false)
                        }
                    });
                } else {
                    handleModal({
                        isOpen: true,
                        contents: res.data.msg,
                        type: "alert",
                    });
                }
            })
        }
    };

    useEffect(() => {
        if (modifyTrigger) {
            saveCallback(getValues("list"))
            setModifyTrigger(false)
        }
    }, [modifyTrigger]);

    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">{menuTitleText}품목</h6>
            <div className="table_toolbar">
                <button className="btn btn-dark w-80px" onClick={btnAdd}>추가</button>
                <button className="btn btn-outline-dark w-100px px-0" onClick={btnDelete}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt=""/>
                    선택삭제
                </button>
            </div>
        </div>
        <div className="table_scroll mb-0">
            <table className="table table-bordered my_table table_detail">
                <thead>
                <tr>
                    <th style={{width: "4%"}}>
                        <div className="checkbox_outer">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isAllCheck}
                                onClick={clickAllCheck}
                            />
                        </div>
                    </th>
                    <th style={{width: "10.5%"}}>제품군</th>
                    <th style={{width: "29.4%"}}>품목</th>
                    <th style={{width: "18.8%"}}>규격</th>
                    <th style={{width: "10.5%"}}></th>
                    <th style={{width: "16.4%"}}></th>
                    <th>수량</th>
                </tr>
                </thead>
                <tbody>
                {watchUpdateData.list.length !== 0
                    ? watchUpdateData.list.map((el, idx) =>
                        <tr>
                            <td>
                                <div className="checkbox_outer">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={checkedIdx.includes(idx)}
                                        onClick={() => clickCheck(idx)}
                                    />
                                </div>
                            </td>
                            <td className="p-4px">
                                <input type="text" className="form-control"
                                       value={el.productGroupName}
                                       disabled/>
                            </td>
                            <td className="p-4px">
                                <div className="d-flex">
                                    <input type="text" className="form-control"
                                           value={el.productName}
                                           disabled/>
                                    <button
                                        className="btn btn-info btn_search w-100px ms-5px"
                                        onClick={() => btnSearchProduct(idx)}>
                                        <img
                                            src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                            alt=""
                                        />찾기
                                    </button>
                                </div>
                            </td>
                            <td className="p-4px">
                                <input type="text" className="form-control"
                                       value={el.newTxtStandard}
                                       disabled/>
                            </td>
                            <td className="text-center"></td>
                            <td className="text-center"></td>
                            <td className="p-4px">
                                <InputNumberUc control={control} name={`list.${idx}.newIQty`}/>
                                {/*<input type="text" className="form-control text-end"
                                       value={el.newIQty}
                                       {...register(`list.${idx}.newIQty`)}
                                />*/}
                            </td>
                        </tr>
                    )
                    : <EmptyTableRow colSpan={7} msg={`${menuTitleText}품목을 추가해주세요.`}/>
                }
                </tbody>
                <tfoot>
                <tr>
                    <td className="text-start grey" colSpan={6}></td>
                    <td className="text-end">
                        {isNaN(watchUpdateData.list.reduce((acc, cur) => acc + Number(cur.newIQty), 0))
                            ? <>-</>
                            : <DisplayNumber
                                value={watchUpdateData.list.reduce((acc, cur) => acc + Number(cur.newIQty), 0)}/>
                        }
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
}